<!--
 * @Author: zhwenlong 2546258285@qq.com
 * @Date: 2022-05-18 09:07:11
 * @LastEditors: zhwenlong 2546258285@qq.com
 * @LastEditTime: 2023-08-23 11:18:11
 * @FilePath: \pig-merchant-system-setting\src\publicElement\zg-el_mask\index.vue
 * @Description: 
 * 
 * Copyright (c) 2022 by zhwenlong 2546258285@qq.com, All Rights Reserved. 
-->
<template>
  <!-- 弹框 -->
  <el-dialog
    :title="title"
    :visible.sync="digStatus"
    :width="size"
    :modal="modal"
    :close-on-click-modal="false"
    :close="closeDig"
  >
    <div class="_customScroll mask_form" :class="{ scroll: scroll }">
      <slot name="body"></slot>
    </div>
    <template v-slot:footer v-if="$slots.foot">
      <slot name="foot"></slot>
    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    // 弹框标题
    title: {
      type: String,
      default: "详情",
    },
    size: {
      type: String,
      default: "840px",
    },
    // 是否可以滚动
    scroll: {
      type: Boolean,
      default: false,
    },
    // 弹框开关
    visible: {
      type: Boolean,
      default: false,
    },
    // 是否需要蒙层
    modal: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    digStatus: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    // 确定
    sccuess() {
      if (!this.sccuessdisabled) {
        this.$emit("sccuess");
      }
    },
    closeDig() {
      this.digStatus = false;
      this.$emit("closeDig");
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
/deep/.el-dialog__header {
  padding: 0 10px;
  height: 40px;
  line-height: 40px;
  background: RGBA(232, 238, 249, 1);
  border-radius: 0px 0px 0px 0px;
  .el-dialog__title {
    line-height: 40px;
    color: #000;
    font-size: 14px;
    font-weight: bold;
  }
}
.mask_form {
  padding: 40px;
}

.scroll {
  max-height: 400px;
  overflow: auto;
}
</style>
<style lang="less" scoped >
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  /* //background-color: #8c8c8c; */
  background-color: rgba(0, 0, 0, 0.25);
}

::-webkit-scrollbar-track {
  background-color: #f6f6f6;
}

::-webkit-scrollbar-thumb,
::-webkit-scrollbar-track {
  border: 0;
}
</style>
